import CDS from "design-system";
import { Task } from "features/Resources/Task/models";
import { useSkipTask } from "features/Resources/Task/hooks";

interface MarkSkippedToggleButtonProps {
  task: Task;
}

export default function MarkSkippedToggleButton({ task }: MarkSkippedToggleButtonProps) {
  const markSkipped = useSkipTask(task);

  if (task?.status === "completed") {
    return null;
  }
  if (task?.status === "skipped") {
    return (
      <CDS.Button
        intent={CDS.Button.intent.secondary}
        variant={CDS.Button.variant.outline}
        size="sm"
        onClick={() => markSkipped()}
      >
        Unskip
      </CDS.Button>
    );
  }
  return (
    <CDS.Button
      intent={CDS.Button.intent.secondary}
      variant={CDS.Button.variant.outline}
      size="sm"
      onClick={() => markSkipped()}
    >
      Skip
    </CDS.Button>
  );
}
